import { useEffect, useState } from 'react';
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false));
    useEffect(() => {
        const m = window.matchMedia(query);
        const h = (e) => setMatches(e.matches);
        setMatches(m.matches);
        m.addEventListener('change', h);
        return () => m.removeEventListener('change', h);
    }, [query]);
    return matches;
}
//# sourceMappingURL=useMediaQuery.js.map